import React, { Fragment, useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/Header/Header";
import HeroSection from "../../components/hero/Hero";
import AboutSection from "../../components/about/about";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import FeatureSection from "../../components/FeatureSection/FeatureSection";
import ProjectSection from "../../components/ProjectSection/ProjectSection";
import IndustriesMarqueeSection from "../../components/IndustriesMarqueeSection/IndustriesMarqueeSection";
import IndustriesSection from "../../components/Industries/Industries";
import LovedByDevelopers from "../../components/LovedByDevelopers/LovedByDevelopers";
import ContactSection from "../../components/ContactSection/ContactSection";
import TestimonialSection from "../../components/Testimonial/Testimonial";
import BlogSection from "../../components/BlogSection/BlogSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import BrandSection from "../../components/FeatureSection/BrandSection";


const HomePage: React.FC = () => {
  return (
    <Fragment>
      <Helmet>
        <title>AquarLabs - Engineering the Intelligent Future | AI Solutions & Digital Transformation</title>
        <meta name="description" content="AquarLabs delivers cutting-edge AI solutions, cloud services, and digital transformation. We specialize in AI Agents, Machine Learning, Generative AI, and enterprise solutions for businesses worldwide." />
        <meta name="keywords" content="AI solutions, artificial intelligence, machine learning, generative AI, cloud services, digital transformation, AI agents, web development, mobile app development, enterprise solutions, AquarLabs" />
        <link rel="canonical" href="https://aquarlabs.com/" />
        <meta property="og:title" content="AquarLabs - Engineering the Intelligent Future" />
        <meta property="og:description" content="Transform your business with AI-powered solutions. AquarLabs offers cutting-edge AI agents, machine learning, cloud services, and digital transformation solutions." />
        <meta property="og:url" content="https://aquarlabs.com/" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="AquarLabs - Engineering the Intelligent Future" />
        <meta name="twitter:description" content="Transform your business with AI-powered solutions. AquarLabs offers cutting-edge AI agents, machine learning, cloud services, and digital transformation solutions." />
      </Helmet>
      <div className='ai-agency'>
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <HeroSection />
            {/* <AboutSection/> */}
            <BrandSection />
            <ServiceSection />
            <FeatureSection />
            <ProjectSection />
            <IndustriesMarqueeSection />
            <IndustriesSection />
            <LovedByDevelopers />
            <ContactSection />
            <TestimonialSection />
            {/* <BlogSection/> */}
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default HomePage;
